export default {
  name: 'AppForm',
  emits: ['submit'],
  methods: {
    onSubmit(e) {
      e.preventDefault();
      this.$emit('submit');
    }
  }
};